import { MediaTile } from "../media/MediaTile.js";
import { Spinner } from "../../shared/ui/index.js";
import { useMySubmissions, type GuestIdentity } from "./guest.api.js";

export function MyUploadsView({
  eventId,
  identity,
  token,
}: {
  eventId: string | undefined;
  identity: GuestIdentity;
  token: string | undefined;
}) {
  const { data, isLoading } = useMySubmissions(eventId, identity.email, token);
  const items = data?.items ?? [];

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (items.length === 0) {
    return (
      <div className="flex h-full flex-col items-center justify-center px-8 text-center">
        <p className="text-sm" style={{ color: "var(--theme-muted)" }}>
          Vous n'avez encore rien envoyé. Vos photos et vidéos apparaîtront ici, visibles
          seulement par vous.
        </p>
      </div>
    );
  }

  return (
    <div className="sv-scroll h-full px-3 py-3">
      <p className="px-1 pb-2 text-xs" style={{ color: "var(--theme-muted)" }}>
        {items.length} envoi{items.length > 1 ? "s" : ""} · visibles seulement par vous
      </p>
      <div className="grid grid-cols-3 gap-1.5">
        {items.map((m) => (
          <MediaTile key={m.id} item={m} />
        ))}
      </div>
    </div>
  );
}
